import { render } from "./securityreport.vue?vue&type=template&id=646a3294&scoped=true"
import script from "./securityreport.vue?vue&type=script&lang=js"
export * from "./securityreport.vue?vue&type=script&lang=js"

import "./securityreport.vue?vue&type=style&index=0&id=646a3294&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-646a3294"]])

export default __exports__